import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { IBaseExportParams, ISafetyInspectionBase, IVehicleExportParams } from '../models/interfaces';
import { QueryUtilsService } from './query-utils.service';
import { FeedbackRequestParams } from '../modules/analytics/shared/types/types';

@Injectable({
  providedIn: 'root'
})
export class ExportService {

  constructor(
    private queryUtilsService: QueryUtilsService
  ) { }

  private openWindow = (url: string): void => {
    window.open(url, '_blank');
  }

  // window.open() can only issue a GET, so a large ids list ends up in the query
  // string and risks hitting URL length limits. This submits a hidden form via
  // POST instead — same ~/ReportViewer.aspx endpoint, same field names, but the
  // ids travel in the form body so there's no length ceiling to worry about.
  private postToWindow = (url: string, fields: { [key: string]: string }): void => {
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = url;
    form.target = '_blank';
    form.style.display = 'none';

    Object.keys(fields).forEach((name: string) => {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.value = fields[name] ?? '';
      form.appendChild(input);
    });

    document.body.appendChild(form);
    try {
      form.submit();
    } finally {
      document.body.removeChild(form);
    }
  }

  public exportCustomer = (): void => {
    const xlsxURL = '/API/Clients/ExportClients/';
    this.openWindow(xlsxURL);
  }

  public exportInspection = (inspections: ISafetyInspectionBase[]): void => {
    const idsString = inspections.map((item: ISafetyInspectionBase) => item.Id).join('|');
    this.postToWindow('/ReportViewer.aspx', { report: 'InspectionReport.xlsx', ids: idsString });
  }

  public exportVehicle = (params: IVehicleExportParams): void => {
    const endpoint = '/api/v3/vehicle/export';
    const xlsxURL = this.queryUtilsService.getPreparedQuery(endpoint, params);
    this.openWindow(xlsxURL);
  }

  public exportCheckItems = (params: IBaseExportParams): void => {
    const endpoint = '/api/v3/safetyItem/export';
    const xlsxURL = this.queryUtilsService.getPreparedQuery(endpoint, params);
    this.openWindow(xlsxURL);
  }

  public exportFeedback = (params: FeedbackRequestParams): void => {
    const endpoint = '/api/v3/analytics/feedback/export';
    const xlsxURL = this.queryUtilsService.getPreparedQuery(endpoint, params);
    this.openWindow(xlsxURL);
  }
}
